import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ConditionalWrapper from 'components/application/ConditionalWrapper';

export default function OptionsItem({
  children,
  isDangerous = false,
  isDisabled = false,
  onClick,
  wrapper,
  wrapperCondition = false,
}) {
  return (
    <li
      className='tw-m-0 tw-cursor-pointer tw-p-0 disabled:tw-cursor-not-allowed'
      data-element-name='options-item'
      disabled={isDisabled}
    >
      <ConditionalWrapper condition={wrapperCondition} wrapper={wrapper}>
        <button
          className={classNames(
            'tw-group tw-flex tw-w-full tw-items-center tw-gap-2 tw-border-none tw-bg-white tw-p-3 tw-text-m tw-font-medium tw-tracking-auto tw-text-grey-700 disabled:tw-bg-grey-050 disabled:tw-text-grey-300',
            isDangerous ?
              'hover:tw-bg-red-025 hover:tw-text-red-700'
            : 'hover:tw-bg-blue-025',
          )}
          disabled={isDisabled}
          onClick={onClick}
        >
          {children}
        </button>
      </ConditionalWrapper>
    </li>
  );
}

OptionsItem.propTypes = {
  children: PropTypes.node.isRequired,
  isDangerous: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  wrapper: PropTypes.func,
  wrapperCondition: PropTypes.bool,
};
